import { customer } from '@icabbi/api-gateway-client';
import { Authentication } from '@icabbi/vue-authentication';
import Decimal from 'decimal.js-light';

const defaultState = {
  chargeQueryClient: null,
};

const getters = {
  // eslint-disable-next-line no-shadow
  chargeQueryClient: (state, getters, rootState, rootGetters) => ({ dispatch }) => {
    if (state.chargeQueryClient === null) {
      const authentication = Authentication({ dispatch, getters: rootGetters });
      const { authenticationFailureInterceptor, bearerTokenInterceptor } = authentication;
      const chargeQueryClient = new customer.ChargeQueryConnector({
        baseURL: process.env.VUE_APP_API_GATEWAY_URL,
        timeout: parseInt('99999', 10),
      });
      chargeQueryClient.httpClient.interceptors.response.use(undefined, error => authenticationFailureInterceptor(error));
      chargeQueryClient.httpClient.interceptors.request.use(config => bearerTokenInterceptor(config));
      state.chargeQueryClient = chargeQueryClient;
    }
    return state.chargeQueryClient;
  },
};

const actions = {

  async listCharges(context, {
    page, maxPerPage, sort, startDate, endDate, dateType, status, dispatchId, dynamicSearch,
  }) {
    try {
      const params = {
        sort, page, maxPerPage, status, dispatchId, dynamicSearch,
      };

      if (dateType === 'captureDate') {
        params.startCaptureDate = startDate;
        params.endCaptureDate = endDate;
      }

      if (dateType === 'payoutDate') {
        params.startPayoutDate = startDate;
        params.endPayoutDate = endDate;
      }

      if (dateType === 'refundDate') {
        params.startRefundDate = startDate;
        params.endRefundDate = endDate;
      }

      if (dateType === 'transactionDate') {
        params.startDate = startDate;
        params.endDate = endDate;
      }

      const chargeQueryClient = context.getters.chargeQueryClient(context);
      const charges = await chargeQueryClient.listCharges(params);
      return charges;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
      context.dispatch(
        'globalMessages/addError',
        { message: 'charge.getChargesError', code: error.code ? error.code : '' },
        { root: true },
      );
      return { errorCode: error.httpStatusCode ? error.httpStatusCode : '500' };
    }
  },

  async refundCharge(context, { chargeId, refundAmount }) {
    try {
      const chargeQueryClient = context.getters.chargeQueryClient(context);

      const body = { chargeId };
      if (refundAmount) body.amount = new Decimal(refundAmount).times(100).toInteger().toNumber();
      const data = await chargeQueryClient.refundCharge(body);
      context.dispatch(
        'globalMessages/addSuccess',
        { message: 'charge.chargeRefunded' },
        { root: true },
      );
      return data;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
      context.dispatch(
        'globalMessages/addError',
        { message: 'charge.refundChargeError', code: error.code ? error.code : '' },
        { root: true },
      );
      return { errorCode: error.httpStatusCode ? error.httpStatusCode : '500' };
    }
  },
};

const mutations = {};

export default {
  namespaced: true,
  state: defaultState,
  getters,
  actions,
  mutations,
};
